import { impermeableLayerDepth, initialWaterTableDepth, slopeAngle, transverseSlopeAngle } from '../conversion/slope';
import { EUnitOfMeasure } from '../shared/enum';
import { redux } from '../store';

export default () => {
    let project = redux.getState().project;
    return {
        [slopeAngle]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 2,
                    [EUnitOfMeasure.Imperial]: 2,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 80,
                    [EUnitOfMeasure.Imperial]: 80,
                },
            },
        },
        [transverseSlopeAngle]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 2,
                    [EUnitOfMeasure.Imperial]: 2,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 80,
                    [EUnitOfMeasure.Imperial]: 80,
                },
            },
        },
        [initialWaterTableDepth]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 0,
                    [EUnitOfMeasure.Imperial]: 0,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: project.data?.slope?.impermeableLayerDepth!,
                    [EUnitOfMeasure.Imperial]: project.data?.slope?.impermeableLayerDepth!,
                },
            },
        },
        [impermeableLayerDepth]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 0,
                    [EUnitOfMeasure.Imperial]: 0,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: undefined,
                    [EUnitOfMeasure.Imperial]: undefined,
                },
            },
        },
    };
};
